import { render, staticRenderFns } from "./GraphDetail28.vue?vue&type=template&id=aef7808a&scoped=true"
import script from "./GraphDetail28.vue?vue&type=script&lang=js"
export * from "./GraphDetail28.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef7808a",
  null
  
)

export default component.exports